import { Component, inject } from '@angular/core';

import { NEW_DESIGN } from '@kros-sk/core/design-version';

@Component({
  selector: 'kros-input-loader',
  templateUrl: './kros-input-loader.component.html',
  styleUrls: ['./kros-input-loader.component.scss'],
  standalone: false,
})
export class KrosInputLoader {
  protected readonly newDesign = inject(NEW_DESIGN, { optional: true });
}
